import Gallery3D from "../../../components/Gallery3D"
import TitleIcon from "./title.svg"

const Start = 0.5
const Tiles = [
  {
    path: "/assets/textures/gallery/residencs/img-2a.jpg",
    position: {
      x: 0 + Start,
      y: 0.4
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "RESIDENCE BALCONY",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/residencs/img-2b.jpg",
    position: {
      x: 2.5 + Start,
      y: 0
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "RESIDENCE LIVING SPACE",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/residencs/img-2c.jpg",
    position: {
      x: 5 + Start,
      y: 0
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "RESIDENCE KITCHEN",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/residencs/img-2d.jpg",
    position: {
      x: 7.5 + Start,
      y: 0
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "RESIDENCE BEDROOM",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/residencs/img-2e.jpg",
    position: {
      x: 10 + Start,
      y: 0
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "RESIDENCE BEDROOM",
      position: { x: 0, y: 0 }
    }
  },
  {
    path: "/assets/textures/gallery/residencs/img-2f.jpg",
    position: {
      x: 12.5 + Start,
      y: 0
    },
    title: {
      label: "",
      position: { x: 0, y: 0 }
    },
    caption: {
      label: "RESIDENCE BATHROOM",
      position: { x: 0, y: 0 }
    }
  }
]
const Title = {
  icon: TitleIcon,
  top: "auto",
  left: "4vw",
  bottom: "3vw",
  right: "auto",
  width: "39vw"
}
const ResidencesGallery = () => (
  <Gallery3D title={Title} tiles={Tiles} speed={0} length={15} />
)

export default ResidencesGallery
